export const accountRoles = [
  { label: "User", value: "user" },
  { label: "Admin", value: "admin" },
];

export default {};
